export const strings = {
  english: {
    description: 'WalkMix Creator enables musicians and creators to produce music easily and creatively in an immersive spherical sound field by using their familiar platform and workflows in 360 Reality Audio Music Format. 360 WalkMix Creator can be used within a studio environment or on the go utilizing only a laptop and headphones.',
    tax: '*Introductory Price (tax included)',
    redirect: 'You will be redirected to an official distributor',
    subscribe: 'SUBSCRIBE',
    or: 'OR',
  },
  japan: {
    description: 'WalkMix Creatorのプラグインを使うことによって、自由自在かつ簡単に”360度全方向から聴こえる立体的な音楽”を、いつも使っているオーディオシステムを使って作ることができます。360 WalkMix Creatorはスタジオでの楽曲制作だけでなく、ノートパソコンとヘッドホンさえあればどこでも使用できます。',
    tax: 'トライアル価格 (税込)',
    redirect: '正規代理店のウェブサイトに移動します',
  },
};
